import { Observable } from 'rxjs';
import { ServiceTypeModel } from 'src/app/store/service-type/model';
import { InteractorResponse } from '../../models/interactor-response';

export abstract class AbstractServiceTypeService {
  public abstract getAll(): Observable<InteractorResponse<ServiceTypeModel[]>>;
}
